function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "20",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9 10.833c2.707 0 4.909-2.242 4.909-5V5c0-2.757-2.202-5-4.91-5-2.706 0-4.908 2.243-4.908 5v.833c0 2.758 2.202 5 4.909 5zM14.99 13.318c-3.848-1.086-8.131-1.086-11.98 0-1.772.5-3.01 2.153-3.01 4.02v2.663h18v-2.663c0-1.867-1.238-3.52-3.01-4.02z",
  fill: "#111"
}));